import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 96,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 16,
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginTop: '20vh',
      paddingLeft: 32,
      paddingRight: 32,
      paddingTop: 32
    }
  },
  heading1: {
    marginBottom: 8
  },
  paragraph: {
    marginBottom: 24,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 16
    }
  },
  btnWrap: {
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%'
    }
  },
  btn: {
    minWidth: 226,
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%'
    }
  },
  btnRight: {
    marginLeft: 16,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginTop: 8
    }
  },
  img: {
    marginTop: 24
  }
}));

export default useStyles;
